// prettier-ignore
// oxlint-disable eslint-plugin-import/no-commonjs
export const iconRegistry = {
  // <pyly-glob-template glob="../../assets/icons/*.svg" template="  [`${filenameWithoutExt}`]: require(`${path}`),">
  [`add-circled-filled`]: require(`../../assets/icons/add-circled-filled.svg`),
  [`ai`]: require(`../../assets/icons/ai.svg`),
  [`alarm-filled`]: require(`../../assets/icons/alarm-filled.svg`),
  [`alarm`]: require(`../../assets/icons/alarm.svg`),
  [`arrow-down`]: require(`../../assets/icons/arrow-down.svg`),
  [`arrow-left`]: require(`../../assets/icons/arrow-left.svg`),
  [`arrow-return-left`]: require(`../../assets/icons/arrow-return-left.svg`),
  [`arrow-right-down`]: require(`../../assets/icons/arrow-right-down.svg`),
  [`arrow-right`]: require(`../../assets/icons/arrow-right.svg`),
  [`arrow-up`]: require(`../../assets/icons/arrow-up.svg`),
  [`badge-filled`]: require(`../../assets/icons/badge-filled.svg`),
  [`badge`]: require(`../../assets/icons/badge.svg`),
  [`book`]: require(`../../assets/icons/book.svg`),
  [`bookmark-filled`]: require(`../../assets/icons/bookmark-filled.svg`),
  [`bookmark`]: require(`../../assets/icons/bookmark.svg`),
  [`bulb`]: require(`../../assets/icons/bulb.svg`),
  [`cart`]: require(`../../assets/icons/cart.svg`),
  [`check-circled-filled`]: require(`../../assets/icons/check-circled-filled.svg`),
  [`check`]: require(`../../assets/icons/check.svg`),
  [`chevron-down-circled`]: require(`../../assets/icons/chevron-down-circled.svg`),
  [`chevron-down`]: require(`../../assets/icons/chevron-down.svg`),
  [`chevron-left`]: require(`../../assets/icons/chevron-left.svg`),
  [`chevron-right`]: require(`../../assets/icons/chevron-right.svg`),
  [`chevron-up-circled`]: require(`../../assets/icons/chevron-up-circled.svg`),
  [`chevron-up-down`]: require(`../../assets/icons/chevron-up-down.svg`),
  [`chevron-up`]: require(`../../assets/icons/chevron-up.svg`),
  [`circle-warning`]: require(`../../assets/icons/circle-warning.svg`),
  [`close-circled-filled`]: require(`../../assets/icons/close-circled-filled.svg`),
  [`close`]: require(`../../assets/icons/close.svg`),
  [`copy`]: require(`../../assets/icons/copy.svg`),
  [`document`]: require(`../../assets/icons/document.svg`),
  [`dumbbell`]: require(`../../assets/icons/dumbbell.svg`),
  [`expand`]: require(`../../assets/icons/expand.svg`),
  [`flag-filled`]: require(`../../assets/icons/flag-filled.svg`),
  [`flag`]: require(`../../assets/icons/flag.svg`),
  [`flame-filled`]: require(`../../assets/icons/flame-filled.svg`),
  [`flame`]: require(`../../assets/icons/flame.svg`),
  [`flash`]: require(`../../assets/icons/flash.svg`),
  [`frown-circled`]: require(`../../assets/icons/frown-circled.svg`),
  [`help-circled`]: require(`../../assets/icons/help-circled.svg`),
  [`home-filled`]: require(`../../assets/icons/home-filled.svg`),
  [`home`]: require(`../../assets/icons/home.svg`),
  [`inbox-filled`]: require(`../../assets/icons/inbox-filled.svg`),
  [`keyboard`]: require(`../../assets/icons/keyboard.svg`),
  [`loader`]: require(`../../assets/icons/loader.svg`),
  [`lock-filled`]: require(`../../assets/icons/lock-filled.svg`),
  [`lock`]: require(`../../assets/icons/lock.svg`),
  [`medal`]: require(`../../assets/icons/medal.svg`),
  [`meh-circled`]: require(`../../assets/icons/meh-circled.svg`),
  [`menu`]: require(`../../assets/icons/menu.svg`),
  [`message-bubble-filled`]: require(`../../assets/icons/message-bubble-filled.svg`),
  [`message-text`]: require(`../../assets/icons/message-text.svg`),
  [`minus`]: require(`../../assets/icons/minus.svg`),
  [`more-horizontal`]: require(`../../assets/icons/more-horizontal.svg`),
  [`note-2`]: require(`../../assets/icons/note-2.svg`),
  [`open`]: require(`../../assets/icons/open.svg`),
  [`pencil`]: require(`../../assets/icons/pencil.svg`),
  [`photos-filled`]: require(`../../assets/icons/photos-filled.svg`),
  [`plant-filled`]: require(`../../assets/icons/plant-filled.svg`),
  [`plus`]: require(`../../assets/icons/plus.svg`),
  [`profile-filled`]: require(`../../assets/icons/profile-filled.svg`),
  [`profile`]: require(`../../assets/icons/profile.svg`),
  [`puzzle`]: require(`../../assets/icons/puzzle.svg`),
  [`redo`]: require(`../../assets/icons/redo.svg`),
  [`repeat`]: require(`../../assets/icons/repeat.svg`),
  [`ruler`]: require(`../../assets/icons/ruler.svg`),
  [`search`]: require(`../../assets/icons/search.svg`),
  [`settings-filled`]: require(`../../assets/icons/settings-filled.svg`),
  [`settings`]: require(`../../assets/icons/settings.svg`),
  [`show`]: require(`../../assets/icons/show.svg`),
  [`shuffle`]: require(`../../assets/icons/shuffle.svg`),
  [`size`]: require(`../../assets/icons/size.svg`),
  [`smile-circled`]: require(`../../assets/icons/smile-circled.svg`),
  [`speaker-2`]: require(`../../assets/icons/speaker-2.svg`),
  [`star-filled`]: require(`../../assets/icons/star-filled.svg`),
  [`star`]: require(`../../assets/icons/star.svg`),
  [`time-circled`]: require(`../../assets/icons/time-circled.svg`),
  [`tone`]: require(`../../assets/icons/tone.svg`),
  [`translate`]: require(`../../assets/icons/translate.svg`),
  [`trash`]: require(`../../assets/icons/trash.svg`),
  [`trending-down`]: require(`../../assets/icons/trending-down.svg`),
  [`trending-up`]: require(`../../assets/icons/trending-up.svg`),
  [`undo`]: require(`../../assets/icons/undo.svg`),
  [`unlock`]: require(`../../assets/icons/unlock.svg`),
  [`voice-square`]: require(`../../assets/icons/voice-square.svg`),
  [`zap-filled`]: require(`../../assets/icons/zap-filled.svg`),
// </pyly-glob-template>
} as const satisfies Record<string, RnRequireSource>;

export type IconRegistry = typeof iconRegistry;
export type IconName = keyof IconRegistry;

export const iconNames = Object.keys(iconRegistry) as readonly IconName[];
